import React from "react";
import { Logo } from "./Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="section-divider relative" data-testid="site-footer">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size={40} />
          </div>
          <div className="md:col-span-3 md:col-start-7">
            <div className="font-label text-[color:var(--bpm-muted)] mb-5">Sitemap</div>
            <ul className="space-y-3 text-[14px]">
              <li><a href="#clients" className="link-underline" data-testid="footer-link-clients">Clients</a></li>
              <li><a href="#services" className="link-underline" data-testid="footer-link-services">Process</a></li>
              <li><a href="#supplemental" className="link-underline" data-testid="footer-link-supplemental">Services</a></li>
              <li><a href="#about" className="link-underline" data-testid="footer-link-about">About</a></li>
              <li><a href="#testimonials" className="link-underline" data-testid="footer-link-testimonials">Testimonials</a></li>
              <li><a href="#contact" className="link-underline" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-[color:var(--bpm-muted)]" style={{ borderTop: "1px solid var(--bpm-line)" }}>
          <div>© {year} Boston Pro Marketing. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
